<template lang="html">

<div id="buildings">

      <el-row class="headLine">
          <el-col :span="12">
              <span>客户查询</span>
          </el-col>
          <el-col :span="12" style="text-align:right;">
              <el-button @click="reList" size="small" type="sccess">刷新</el-button>
          </el-col>
      </el-row>

      <div class="pgContent">

        <el-table border
            header-cell-class-name="dHead"
            v-loading="loading"
            :data="tbData">

            <el-table-column fixed="left" align="center" width="60" label="序号">
                <template slot-scope="scope">
                     {{ scope.$index + (params.no - 1)*params.size + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="realName" fixed="left" align="center" min-width="150" label="客户昵称" />
            <el-table-column prop="park" align="center" width="150" label="性别" />
            <el-table-column prop="jiexiang" align="center" width="90" label="地区" />
            <el-table-column prop="cellPhone" align="center" min-width="120" label="手机号" />
            <el-table-column prop="registerTime" align="center" width="150" label="授权时间" />
            <el-table-column prop="totalVacantArea" align="center" width="180" label="最后登录时间" />

        </el-table>

        <div class="table-footer">

           <el-pagination
             class="paging"
             v-if="allPages>1"
             @current-change="pageChange"
             :current-page="params.no"
             :page-size="params.size"
             layout="total, prev, pager, next, jumper"
             :total="params.allEls">
           </el-pagination>

       </div>



      </div>

</div>

</template>

<script>
import { getUserList } from '@/api/industryInfos';
export default {
    data(){
        return{
            tbData:[],
            allPages:0,
            params:{
                no:1,
                size:10,
                allEls:0
            },
        }
    },
    methods:{
      pageChange(e){
         this.params.no = e;
         this.getList();
      },

      getList(){
          this.loading = true;
          getUserList(this.params).then(res => {
              this.loading = false;
              this.tbData = res.userListByWhereList;
              this.allPages = res.totalPages;
              this.params.allEls = res.totalElements;
          })
      },

      reList(){
          this.params.no = 1;
          this.getList();
      }
    },

    created(){
      this.getList();
    }
}
</script>

<style lang="scss" scoped>

#buildings{
    font-size: 15px;

    .headLine{
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }
    .seekLine{
        padding: 20px;
        padding-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
        .inpItem{
            padding-right: 20px;
            margin-bottom: 20px;
            .inpName{
                width: 120px;
                float: left;
                font-size: 14px;
                text-align: right;
                padding-top: 6px;
            }
            .inpContent{
                margin-left: 120px;
            }
        }

    }

    .pgContent{
        padding: 20px;

        .table-footer{
            margin-top: 20px;
            text-align: right;
        }
    }

}

</style>

<style lang="scss">

#buildings{
    .el-input__inner{
        border-radius: 0px;
    }
    .dHead{
        background: #f5f5f5;
        font-weight: normal;
    }
}

</style>



// WEBPACK FOOTER //
// index.vue?05526b47